import { useEffect, useRef, useState } from 'react';
import Tooltip, { TooltipDirection, TooltipSize } from '../../../lib/Tooltip';

interface Props<H extends HTMLElement = HTMLDivElement> {
  tooltip?: React.ReactNode;
  children: (ref: React.RefObject<H>) => React.ReactElement;
}

export const TruncatedElementWithTooltip = <H extends HTMLElement = HTMLDivElement>({
  children,
  tooltip,
}: Props<H>): React.ReactElement => {
  const ref = useRef<H>(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const content = children(ref);

  useEffect(() => {
    if (ref.current) {
      setIsTruncated(ref.current.scrollWidth > ref.current.clientWidth);
    }
  }, []);

  if (!tooltip || !isTruncated) return content;

  return (
    <Tooltip tooltip={tooltip} direction={TooltipDirection.BOTTOM} size={TooltipSize.FIT}>
      {content}
    </Tooltip>
  );
};
